export default "__VITE_ASSET__CMiB3DRU__"